<template>
  <div id="ClinicianTypeMatchQuestion"></div>
</template>

<script>
export default {
  name: "ClinicianTypeMatchQuestion",
  props: ["setAnswer"],
  mounted() {
    this.setAnswer(true);
  }
};
</script>

<style lang="less"></style>
